import { render, staticRenderFns } from "./deleteAllocationOrder.vue?vue&type=template&id=5768903c"
import script from "./deleteAllocationOrder.vue?vue&type=script&lang=js"
export * from "./deleteAllocationOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports